<div class="profile-container">
<ng-container *ngIf="user">
    <div class="profile-header">
        <div class="user-icon-container">
            <mat-icon class="user-icon">account_circle</mat-icon>
        </div>
        <div class="title-container">
            {{ 'SHARED.PROFILE' | translate }}
        </div>
    </div>
    <hr class="wsh-hr">
    <div class="basic-info-container">
        
            <div class="user-info-container">
                <div class="user-info-label">
                    {{ 'SHARED.FULL_NAME' | translate }}:
                </div>
                <div class="user-info-value">
                    {{ user.name }}
                </div>
            </div>
            <div class="user-info-container">
                <div class="user-info-label">
                    {{ 'SHARED.EMAIL' | translate }}:
                </div>
                <div class="user-info-value">
                    {{ user.email }}
                    <mat-icon class="ml-2 clickable" [matTooltip]="'PROFILE.EDIT-EMAIL' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="showEmailForm()">edit</mat-icon>
                    <!-- <mat-icon *ngIf="pendingEmail" class="ml-2 clickable" [matTooltip]="'PROFILE.PENDING-EMAIL-CHANGE-REQUEST' | translate : {email: pendingEmail}" matTooltipPosition="above" matTooltipHideDelay="200">warning</mat-icon> -->
                </div>
            </div>
            <div class="user-info-container">
                <div class="user-info-label">
                    {{ 'SHARED.PASSWORD' | translate }}:
                </div>
                <dx-button class="ml-2 navbar-button" [height]="30" stylingMode="contained" icon="key" [text]="'PASSWORD.CHANGE_PASSWORD' | translate" type="info" (onClick)="showPasswordForm()"></dx-button>

            </div>

    </div>
</ng-container>
</div>
<dx-popup width="400px" maxWidth="80%" height="190px" [title]="'PROFILE.EDIT-EMAIL' | translate" [(visible)]="displayEmailForm">
    <dx-form #emailChangeForm [formData]="emailFormData" [showColonAfterLabel]="false">
        <dxi-item dataField="email" editorType="dxTextBox" [editorOptions]="{ mode: 'email', maxLength: 60 }">
            <dxo-label location="left" alignment="left" [text]="'SHARED.EMAIL' | translate"></dxo-label>
            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            <dxi-validation-rule type="email" [message]="'VALIDATION.EMAIL' | translate"></dxi-validation-rule>
        </dxi-item>
    </dx-form>
    <hr class="wsh-hr">
    <div class="dx-popup-footer">
        <dx-button class="ml-2 navbar-button" [height]="35" stylingMode="contained" icon="save" [text]="'SHARED.SAVE_CHANGES' | translate"  type="success" (onClick)="submitEmail()" [disabled]="emailFormData.email?.length == 0 || loadingService.unfinishedRequests"></dx-button>


        <dx-button class="ml-2 navbar-button" [height]="35" stylingMode="contained" icon="close" [text]="'SHARED.CLOSE-ALT' | translate"  type="button" (onClick)="displayEmailForm = false"></dx-button>

    </div>
</dx-popup>


<dx-popup width="400px" maxWidth="80%" height="300px" [title]="'PASSWORD.CHANGE_PASSWORD' | translate" [(visible)]="displayPasswordForm">
    <dx-form #passwordChangeForm [formData]="passwordFormData" [showColonAfterLabel]="false">
        <dxi-item dataField="oldPassword" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', mode: 'password', maxLength: 60 }">
            <dxo-label location="left" alignment="left" [text]="'PASSWORD.OLD_PASSWORD' | translate"></dxo-label>
            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="newPassword" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', mode: 'password', maxLength: 20 }">
            <dxo-label location="left" alignment="left" [text]="'PASSWORD.NEW_PASSWORD' | translate"></dxo-label>
            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="repeatPassword" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', mode: 'password', maxLength: 60 }">
            <dxo-label location="left" alignment="left" [text]="'PASSWORD.REPEAT_PASSWORD' | translate"></dxo-label>
            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison" [message]="'VALIDATION.PASSWORD_MATCH' | translate"></dxi-validation-rule>
        </dxi-item>
    </dx-form>
    <hr class="wsh-hr">
    <div class="dx-popup-footer">
        <dx-button class="ml-2 navbar-button button-default" [height]="35" stylingMode="contained" icon="save" [text]="'SHARED.SAVE_CHANGES' | translate"  type="success" (onClick)="submitPassword()" [disabled]="passwordFormData.oldPassword?.length == 0 || passwordFormData.newPassword?.length == 0 || passwordFormData.repeatPassword?.length == 0 || passwordFormData.newPassword != passwordFormData.repeatPassword || loadingService.unfinishedRequests"></dx-button>

        <dx-button class="ml-2 navbar-button button-secondary" [height]="35" stylingMode="contained" icon="close" [text]="'SHARED.CLOSE-ALT' | translate"  type="button" (onClick)="displayPasswordForm = false"></dx-button>
    </div>
</dx-popup>

